
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
import clientLogosData from '@/data/client-logos.json';

import 'swiper/css/pagination';
import 'swiper/css'; // Swiper core styles

interface ClientLogo {
  id: string;
  name: string;
  logo_url: string;
  website_url: string | null;
  display_order: number;
  is_active: boolean;
}

const ClientEngagements = () => {
  const logos = (clientLogosData as ClientLogo[])
    .filter(logo => logo.is_active)
    .sort((a, b) => (a.display_order || 0) - (b.display_order || 0));

  if (logos.length === 0) return null;

  return (
    <section className="section-padding bg-gradient-to-br from-slate-50 to-blue-50/50">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16 animate-on-scroll">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-foreground font-heading">
            Client Engagements
          </h2>
          <div className="h-1 w-20 bg-primary mx-auto mb-6"></div>
          <p className="text-lg md:text-xl text-muted-foreground">
            Trusted by leading organizations across industries to deliver
            innovative solutions
          </p>
        </div>

        <Swiper
          modules={[Autoplay, FreeMode, Pagination]}
          slidesPerView={2}
          spaceBetween={30}
          loop={true}
          autoplay={{
            delay: 1700,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 5 },
          }}
          className="!pb-24"
        >
          {logos.map((logo) => (
            <SwiperSlide
              key={logo.id}
              className="flex justify-center items-center"
            >
              {logo.website_url ? (
                <a
                  href={logo.website_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <img
                    src={logo.logo_url}
                    alt={logo.name}
                    className="h-16 md:h-20 lg:h-24 object-contain grayscale hover:grayscale-0 opacity-80 hover:opacity-100 transition-all duration-500"
                  />
                </a>
              ) : (
                <img
                  src={logo.logo_url}
                  alt={logo.name}
                  className="h-16 md:h-20 lg:h-24 object-contain grayscale hover:grayscale-0 opacity-80 hover:opacity-100 transition-all duration-500"
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ClientEngagements;
